import { updateSelectedTeam } from "@app/state/actions";
import { useGlobalStore } from "@app/state/store";
import type { Team } from "@globals";
import type { Middleware } from "openapi-fetch";

export const teamMiddleware: Middleware = {
  onRequest: ({ request }: { request: Request }) => {
    const { user, selectedTeam } = useGlobalStore.getState();

    if (null === user) {
      return request;
    }

    if (null === selectedTeam) {
      return request;
    }

    request.headers.set("X-TEAM-ID", selectedTeam.id);
    return request;
  },
  onResponse: async ({ response }: { response: Response }) => {
    // check if selected team is same as in response body, otherwise, update selected team
    // this happens, for example, when user pastes a URL of an object that belongs to another team
    const { selectedTeam } = useGlobalStore.getState();

    // Only read response body if request was successful
    if (!response.ok) {
      return response;
    }

    const data = (await response
      .clone()
      .json()
      .catch(() => null)) as { team?: Team } | null;

    if (!data) {
      return response;
    }

    if (data.team && selectedTeam && data.team.id !== selectedTeam.id) {
      // Whenever the user accesses a resource in a Team while on their Personal Workspace
      await updateSelectedTeam(data.team);
    } else if (data.team === null && selectedTeam) {
      // Whenever the user accesses a resource in their Personal Workspace while on a Team
      await updateSelectedTeam(null);
    } else if (data.team && selectedTeam === null && data.team.id) {
      // Whenever the user accesses a resource in a Team while on a different Team
      await updateSelectedTeam(data.team);
    }

    return response;
  }
};
